var _circle, _circle2, _path, _path2, _rect, _circle3, _circle4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatBiography(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#e3eeff",
    stroke: "#a0c0f0",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 28,
    r: 10,
    fill: "#f5c8a0",
    stroke: "#d4956a",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 64 Q24 48 40 46 Q56 48 56 64",
    fill: "#4a80d4",
    stroke: "#2c5bb5",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 46 L40 52 L45 46",
    fill: "#fff",
    stroke: "#2c5bb5",
    strokeWidth: 1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 52,
    width: 6,
    height: 8,
    rx: 1,
    fill: "#e84040",
    stroke: "#b02020",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 63,
    r: 5,
    fill: "#f9d64f",
    stroke: "#c8a800",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 63,
    r: 3,
    fill: "#fce990",
    stroke: "#c8a800",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 60.5 L40.8 62.3 L42.8 62.5 L41.4 63.8 L41.8 65.8 L40 64.8 L38.2 65.8 L38.6 63.8 L37.2 62.5 L39.2 62.3Z",
    fill: "#c8a800"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatBiography);
export default __webpack_public_path__ + "static/media/cat-biography.e50a5bc9e39334185ef4efc43765b65c.svg";
export { ForwardRef as ReactComponent };